<template>
  <odd-page :title="name" subtitle="Edit">
    <template v-slot:header>
      <div class="d-flex flex-row justify-content-end align-items-end h-100">
        <d-dropdown
          v-if="uses_post_purchase_content || uses_customizations"
          theme="dark"
          size="sm"
          noCaret
          class="mx-2 radius bg-black"
          round
          right
          closeOnClick
        >
          <template v-slot:button-content>
            <i class="material-icons">more_horiz</i>
          </template>
          <template>
            <d-dropdown-item
              v-if="uses_post_purchase_content"
              @click="handleEditEmail()"
              tag="button"
              :icon="add"
              iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Email
            </d-dropdown-item>
            <d-dropdown-item
              v-if="uses_post_purchase_content"
              @click="handleEditPostPurchaseContent()"
              tag="button"
              :icon="add"
              iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Page
            </d-dropdown-item>
            <d-dropdown-item
              v-if="uses_customizations"
              @click="handleEditCustomizations()"
              tag="button"
              :icon="add"
              iconTheme="primary"
              class="btn-sm"
            >
              Edit Customizations
            </d-dropdown-item>
          </template>
        </d-dropdown>
      </div>
    </template>
      <!-- <template v-slot:sidebar>
      <ProductEditCard />
    </template> -->
    <template>
      <d-tabs>
        <d-tab title="General" active>
          <d-card class="card-small blog-comments my-2">
            <d-card-header class="border-bottom">
              <h6 class="m-0">General</h6>
            </d-card-header>
            <d-card-body class="p-0">
              <div class="border-bottom px-3 pb-3">
                <odd-label>Name</odd-label>
                <d-input
                  v-model="name"
                  :state="validName ? null : false"
                  class="mb-0"
                />
                <small class="text-light text-right">slug: {{ slug }}</small>
                <small v-if="!validName" class="mt-2">A name is required</small>
              </div>
              <div class="border-bottom px-3 pb-3">
                <odd-label>Receipt Line</odd-label>
                <d-input v-model="receipt_line" />
              </div>
              <div class="border-bottom px-3 pb-3">
                <odd-label>SKU</odd-label>
                <d-input v-model="sku" />
              </div>

              <div class="border-bottom px-3 pb-3">
                <odd-label>Categories</odd-label>
                <template v-for="category in allProductCategories">
                  <d-checkbox
                    :key="category.key"
                    v-model="categories"
                    name="categories"
                    :value="category.id"
                  >
                    <span
                      :class="{
                        'text-light': !category.enabled,
                        'text-line-through': !category.enabled
                      }"
                    >
                      {{ category.name }}
                    </span>
                    <sup
                      v-if="!category.enabled"
                      class="text-monospace pl-2 text-light"
                      style="fontSize: .58em"
                    >
                      [NOT PUBLISHED]
                    </sup>
                  </d-checkbox>
                </template>
              </div>
              <div v-if="uses_collections" class="border-bottom px-3 pb-3">
                <odd-label>Collections</odd-label>
                <template v-for="collection in productCollections">
                  <d-checkbox
                    :key="collection.id"
                    v-model="collections"
                    name="collections"
                    :value="collection.id"
                  >
                    <span>
                      {{ collection.name }}
                    </span>
                    <sup
                      v-if="collection.custom_fulfillment"
                      class="text-monospace pl-2 text-info"
                      style="fontSize: .58em"
                      >[CUSTOM FULFILLMENT]</sup
                    >
                  </d-checkbox>
                </template>
                <small class="text-monospace text-info" style="fontSize: .58em"><i class="material-icons">star</i> Only a single Custom Fulfillment Collection can be assigned to a product</small>
              </div>
              <div v-if="merchantOptions.length > 0" class="px-3 pb-3">
                <odd-label>Merchant</odd-label>
                <d-form-select
                  v-model="merchantID"
                  :options="merchantOptions"
                />
              </div>
            </d-card-body>
          </d-card>
        </d-tab>
        <d-tab title="Product Page">
          <d-card class="card-small blog-comments my-2">
            <d-card-header class="border-bottom">
              <h6 class="m-0">Product Page</h6>
            </d-card-header>
            <d-card-body class="p-0">
              <div class="border-bottom px-3 pb-3">
                <odd-label>Instruction Set</odd-label>
                <d-input v-model="instruction_set" />
                <small>
                  Use the | symbol to separate instruction options on the
                  product page
                </small>
              </div>

              <div class="border-bottom px-3 pb-3">
                <odd-label>
                  Description
                </odd-label>
                <quill-editor
                  ref="myQuillEditor"
                  v-model="description"
                  :options="quillOptions"
                />
              </div>
              <div class="border-bottom px-3 pb-3">
                <odd-label>Short Description</odd-label>
                <d-input v-model="short_description" />
                <small class="mt-2"
                  >Used for Social Media, Search Listings, Etc.</small
                >
              </div>
              <div class="px-3 pb-3">
                <div class="d-flex align-items-center">
                  <odd-label>
                    Product Photos
                  </odd-label>
                  <odd-spinner
                    v-if="loadingMedia"
                    :size="16"
                    style="margin-bottom: -10px; margin-left: 10px;"
                  />
                </div>

                <d-row v-if="media_collection" class="mb-2">
                  <template v-for="image in media.images">
                    <d-col :key="image.id" cols="6" md="3">
                      <d-card>
                        <d-card-img
                          :src="
                            `${isDev ? 'http://localhost:8000' : ''}${
                              image.thumbnails.md_thumbnail
                            }`
                          "
                          top
                        />
                        <d-card-body class="py-2 border-top">
                          <d-button
                            size="sm"
                            theme="danger"
                            class="mr-2"
                            @click="handleDeleteImage(image.id)"
                            ><i class="material-icons">close</i></d-button
                          >
                          <d-link
                            class="btn btn-sm btn-secondary mx-2"
                            :href="image.image"
                            target="_blank"
                          >
                            <i class="material-icons">get_app</i>
                          </d-link>
                        </d-card-body>
                      </d-card>
                    </d-col>
                  </template>
                </d-row>
                <d-row>
                  <d-col cols="12">
                    <vue-dropzone
                      :options="dropzoneOptions"
                      :url="imageUploadUrl"
                      @success="handleUploadSuccess"
                      duplicateCheck
                    />
                    <small class="text-gray">
                      *Images are live as soon as they are uploaded, ignoring
                      the save and cancel buttons.
                    </small>
                  </d-col>
                </d-row>
              </div>
            </d-card-body>
          </d-card>
        </d-tab>
        <d-tab title="Pricing">
          <d-card class="card-small blog-comments my-2">
            <d-card-header class="border-bottom d-flex justify-content-between">
              <h6 class="m-0 flex-1">Pricing</h6>
              <d-form-select
                v-if="shopSettings.charge_strategy === 'authorize_then_capture'"
                size="sm"
                v-model="pricing_model"
                :options="pricingModelOptions"
                style="max-width: 200px"
                class="form-control-sm"
              />
            </d-card-header>
            <d-card-body class="p-0">
              <div v-if="pricing_model === 'regular'">
                <div class="border-bottom px-3 pb-3">
                  <odd-label>Base Price</odd-label>
                  <currency-input v-model="base_price" class="form-control" />
                </div>
              </div>
              <div v-else-if="pricing_model === 'weight'">
                <d-row class="border-bottom mx-0">
                  <d-col cols="12" md="6" class="border-right px-3 pb-3">
                    <odd-label>Base Price</odd-label>
                    <currency-input v-model="base_price" class="form-control" />
                  </d-col>
                  <d-col cols="12" md="6" class="px-3 pb-3">
                    <odd-label>Per</odd-label>
                    <d-row>
                      <d-col cols="12" md="6">
                        <d-form-select
                          v-model="per_label"
                          :options="perLabelOptions"
                        />
                      </d-col>
                      <d-col cols="12" md="6" v-if="perLabelIsOther">
                        <d-input v-model="per_label_other" placeholder="Per"
                      /></d-col>
                    </d-row>
                  </d-col>
                </d-row>
                <d-row class="border-bottom mx-0">
                  <d-col cols="12" md="6" class="border-right px-3 pb-3">
                    <odd-label>Sell by Quantity</odd-label>
                    <d-input v-model="sell_by_quantity" />
                  </d-col>
                  <d-col cols="12" md="6" class="px-3 pb-3">
                    <odd-label>Sell by Label</odd-label>
                    <d-row>
                      <d-col cols="12" md="6">
                        <d-form-select
                          v-model="sell_by_label"
                          :options="sellByLabelOptions"
                        />
                      </d-col>
                      <d-col cols="12" md="6" v-if="sellByLabelIsOther">
                        <d-input
                          v-model="sell_by_label_other"
                          placeholder="Sell By Label"
                      /></d-col>
                    </d-row>
                  </d-col>
                </d-row>
              </div>
              <div class="px-3 pb-3">
                <odd-label>Tax Rate (enter as a percentage)</odd-label>
                <!-- <d-checkbox v-model="taxEnabled" ><span v-if="taxEnabled">Charge Tax for Product</span></d-checkbox> -->
                <!-- <Toggle v-model="taxEnabled"/> -->
                <d-input v-model="tax_rate" />
                <small>{{ tax_rate }}%</small>
              </div>
            </d-card-body>
          </d-card>
        </d-tab>
        <d-tab title="Availability">
          <d-card class="card-small blog-comments my-2">
            <d-card-header class="border-bottom">
              <h6 class="m-0 flex-1">Availability</h6>
            </d-card-header>
            <d-card-body class="p-0">
              <div class="px-3 pb-3">
                <odd-label>Available Date</odd-label>
                <d-datepicker
                  v-model="available_on"
                  format="yyyy-MM-dd"
                  typeable
                />
                <small>
                  Published must be checked for product to be available after on
                  this date.
                </small>
              </div>
              <div v-if="uses_coming_soon" class="px-3 pb-3">
                <odd-label>Comming Soon Until</odd-label>
                <datetime v-model="coming_soon" type="datetime"></datetime>
                <small>
                  Products must be available to be listed as "coming soon" on
                  your site.
                </small>
              </div>
              <!-- <div class="border-bottom px-3 pb-3 d-none">
                <odd-label>Coming Soon Date</odd-label>
                <d-datepicker
                  v-model="comming_soon"
                  format="yyyy-MM-dd"
                  typeable
                  time
                />
                <small
                  >If this field is filled out items will be displayed as filled
                  out items will be displayed as "Coming Soon" until the
                  selected date has passed.
                </small>
              </div> -->
            </d-card-body>
          </d-card>

          <d-card>
            <div class="px-3 pb-3">
              <d-checkbox class="my-2" v-model="published"
                >PUBLISHED</d-checkbox
              >
              <d-checkbox class="my-2" v-model="available_on_pos"
                >DISPLAY ON POS</d-checkbox
              >
            </div>
          </d-card>

          <d-card class="mt-3" v-if="!!merchantID && uses_limited_release">
            <d-card-header class="border-bottom">
              <h6 class="m-0 flex-1">Limited Release Schedule</h6>
            </d-card-header>
            <div class="px-3 pb-3">
              <LimitedReleaseSchedule
                v-model="limitedRelease"
                :merchantID="merchantID"
              />
            </div>
          </d-card>
        </d-tab>
        <d-tab title="Misc">
          <d-card v-if="!!shopConfig" class="card-small blog-comments my-2">
            <d-card-header class="border-bottom">
              <h6 class="m-0 flex-1">Misc</h6>
            </d-card-header>
            <d-card-body class="p-0">
              <CustomFields
                :fields="shopConfig.custom_fields"
                v-model="custom_values"
              />
            </d-card-body>
          </d-card>
        </d-tab>
      </d-tabs>

      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="updateProduct"
          text="Save"
          loadingText="saving..."
          :loading="saving && savingProduct && savingLimitedRelease"
        />
      </div>

    </template>
  </odd-page>
</template>

<script>
import { mapGetters } from "vuex";

import Page from "@/components/layout/Page/Page.vue";
import { quillEditor } from "vue-quill-editor";
import quillDefaultOptions from "@/utils/quillOptions";
import VueDropzone from "@/components/vue2-dropzone/components/vue-dropzone.vue";
import ProductsAPI from "@/store/modules/products/data";
import formatters from "@/components/DataGrid/formatters";
import Toggle from "@/components/Toggle.vue";
import CustomFields from "./CustomFields";
import LimitedReleaseSchedule from "./LimitedReleaseSchedule";
import ProductEditCard from '@/components/ProductEditCard'

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  data() {
    return {
      isDev: process.env.NODE_ENV === "development",
      compareLimitedRelease: "[]",
      limitedRelease: [],
      limitedReleaseID: "",
      uploadResponse: null,
      custom_values: {},
      header_image: "",
      merchantID: "",
      quillOptions: quillDefaultOptions,
      loading: true,
      loadingMediaCount: 0,
      saving: false,
      savingProduct: false,
      savingLimitedRelease: false,
      validName: true,
      results: {},
      categoryImgSrc: "",
      instruction_set: "",
      receipt_line: "",
      published: null,
      available_on: "",
      coming_soon: null,
      name: "",
      slug: "",
      description: "",
      short_description: "",
      note: "",
      categories: [],
      collections: [],
      taxEnabled: true,
      nutrition: {},
      base_price: null,
      variants: {},
      customizations: {},
      tags: [],
      created: null,
      updated: null,
      tax_rate: null,
      sku: "",
      available_on_pos: null,
      media_collection: null,
      media: [],
      formatters,
      pricing_model: "regular",
      pricingModelOptions: [
        { value: "regular", text: "Regular Pricing" },
        { value: "weight", text: "Price By Weight" }
      ],
      per_label: "other",
      per_label_other: "",
      perLabelOptions: [
        { value: "lb", text: "Pound" },
        { value: "oz", text: "Ounce" },
        { value: "", text: "Other" }
      ],
      sell_by_quantity: 1.0,
      sell_by_label: "each",
      sell_by_label_other: "",
      sellByLabelOptions: [
        { value: "each", text: "Each" },
        { value: "lb", text: "Pound" },
        { value: "dozen", text: "Dozen" },
        { value: "", text: "Other" }
      ],
      merchantOptions: []
    };
  },
  created() {
    this.$store.dispatch("products/get", this.$route.params.key).then(data => {
      this.media_collection = data.media_collection;
      this.merchantID = data.merchant;
      this.published = data.published;
      this.available_on = data.available_on;
      this.coming_soon = data._coming_soon;
      this.pricing_model = data.pricing_model;
      this.name = data.name;
      this.slug = data.slug;
      this.description = data.description;
      this.short_description = data.short_description;
      this.note = data.note;
      this.categories = data.categories;
      this.collections = data.collections;
      this.nutrition = data.nutrition;
      this.base_price = data.base_price;
      this.variants = data.variants;
      this.per_label = data.per_label;
      this.customizations = data.customizations;
      this.instruction_set = data.instruction_set;
      this.tags = data.tags;
      this.created = data.created;
      this.updated = data.updated;
      this.tax_rate = data.tax_rate;
      this.sku = data.sku;
      this.receipt_line = data.receipt_line;
      this.available_on_pos = data.available_on_pos;
      this.sell_by_quantity = data.sell_by_quantity;

      if (JSON.stringify(data.custom_values) === "[]") {
        this.custom_values = {};
      } else {
        this.custom_values = data.custom_values;
      }
      if (["each", "lb", "dozen"].includes(data.sell_by_label)) {
        this.sell_by_label = data.sell_by_label;
      } else {
        this.sell_by_label = "";
        this.sell_by_label_other = data.sell_by_label;
      }

      if (["each", "lb", "dozen"].includes(data.per_label)) {
        this.per_label = data.per_label;
      } else {
        this.per_label = "";
        this.per_label_other = data.per_label;
      }

      if (!!data.limited_release) {
        this.limitedReleaseID = data.limited_release;
        this.$store
          .dispatch("products/getLimitedRelease", this.$route.params.key)
          .then(data => {
            this.limitedRelease = data.pickup_schedule;
            this.complareLimitedRelease = JSON.stringify(data.pickup_schedule);
          });
      }
    });

    this.$store.dispatch("merchants/init").then(data => {
      const list = [];
      data.forEach(row => {
        list.push({ value: row.id, text: row.name });
      });
      this.merchantOptions = list;
    });

    // ,
    //             { value: 'first', text: 'This is the first option' },
    //             { value: 'second', text: 'This is the second option' },
    //             { value: 'disabled', text: 'This one is disabled', disabled: true }
  },
  computed: {
    key() {
      return this.$route.params.key;
    },
    uses_post_purchase_content() {
      return this.$store.getters["settings/uses_post_purchase_content"];
    },
    uses_customizations() {
      return this.$store.getters["settings/uses_customizations"];
    },
    uses_coming_soon() {
      return this.$store.getters["settings/uses_coming_soon"];
    },
    uses_limited_release() {
      return this.$store.getters["settings/uses_limited_release"];
    },
    uses_collections() {
      return this.$store.getters["settings/uses_collections"];
    },
    productCollections() {
      return this.$store.state.productCollections.list;
    },
    shopConfig() {
      return !!this.$store.state.settings.settings.shop_config
        ? this.$store.state.settings.settings.shop_config
        : null;
    },
    imageUploadUrl() {
      return ProductsAPI.IMAGE_UPLOAD_URL(this.key);
    },
    allProductCategories() {
      if (
        !!this.$store.state.productCategories.list &&
        !!this.$store.state.productCategories.list.results
      ) {
        return this.$store.state.productCategories.list.results;
      }
      return [];
    },
    dropzoneOptions() {
      return {
        thumbnailWidth: 150,
        maxFilesize: 1.5
      };
    },
    loadingMedia() {
      return this.loadingMediaCount > 0;
    },
    sellByLabelIsOther() {
      return !!this.sellByLabelOptions.find(
        o => o.value === this.sell_by_label && !!!this.sell_by_label
      );
    },
    perLabelIsOther() {
      return !!this.perLabelOptions.find(
        o => o.value === this.per_label && !!!this.per_label
      );
    },
    shopSettings() {
      return this.$store.state.shop.settings;
    }
  },
  components: {
    CustomFields,
    quillEditor,
    VueDropzone,
    "odd-page": Page,
    Toggle,
    LimitedReleaseSchedule,
    Datetime,
    ProductEditCard
  },
  watch: {
    media_collection(value) {
      this.getMedia(value);
    },
    editPK(value) {
      if (value === null) {
        this.resetForm();
      } else {
        this.loadProductCategory();
      }
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
      this.description = html;
    },
    validateName() {
      this.validName = 3 < this.name.length && this.name.length < 100;
    },
    handleUploadSuccess(file, response) {
      this.getMedia(this.media_collection);
    },
    handleDeleteImage(key) {
      this.loadingMediaCount++;
      this.$store
        .dispatch("mediaCollection/imageDelete", key)
        .then(() => {
          this.getMedia(this.media_collection);
        })
        .finally(() => {
          this.loadingMediaCount--;
        });
    },
    getMedia(key) {
      if (key !== null) {
        this.loadingMediaCount++;
        this.$store
          .dispatch("mediaCollection/get", key)
          .then(collection => {
            this.media = collection;
          })
          .finally(() => {
            this.loadingMediaCount--;
          });
      } else {
        this.media = [];
      }
    },
    handleEditEmail() {
      this.$router.push({
        name: "products__edit__email",
        params: { key: this.$route.params.key }
      });
    },
    handleEditPostPurchaseContent() {
      this.$router.push({
        name: "products__edit__post_purchase_content",
        params: { key: this.$route.params.key }
      });
    },
    handleEditProductMeta() {
      this.$router.push({
        name: "products__edit__meta",
        params: { key: this.$route.params.key }
      });
    },
    handleEditCustomizations() {
      this.$router.push({
        name: "products__edit__customizations",
        params: { key: this.$route.params.key }
      });
    },
    validate() {
      this.validateName();
      return this.validName;
    },
    updateProduct() {
      if (this.validate()) {
        this.savingProduct = true;
        let sell_by_label = this.sell_by_label;
        if (!["each", "lb", "dozen"].includes(sell_by_label)) {
          sell_by_label = this.sell_by_label_other;
        }

        let per_label = this.per_label;
        if (!["each", "lb", "dozen"].includes(per_label)) {
          per_label = this.per_label_other;
        }

        const product = {
          key: this.key,
          name: this.name,
          merchant: this.merchantID,
          slug: this.slug,
          receipt_line: this.receipt_line,
          description: this.description,
          short_description: this.short_description,
          note: this.note,
          sku: this.sku,
          instruction_set: this.instruction_set,
          categories: this.categories,
          collections: this.collections,
          base_price: this.base_price,
          tax_rate: this.tax_rate,
          pricing_model: this.pricing_model,
          available_on: this.available_on,
          _coming_soon: this.coming_soon,
          published: this.published,
          available_on_pos: this.available_on_pos,
          sell_by_quantity: this.sell_by_quantity,
          per_label: per_label,
          sell_by_label: sell_by_label,
          custom_values: this.custom_values
        };

        this.$store.dispatch("products/update", product).then(result => {
          this.savingProduct = false;
          if (
            this.compareLimitedRelease !== JSON.stringify(this.limitedRelease)
          ) {
            this.savingLimitedRelease = true;
            const updateLimitedRelease = {
              productID: this.key,
              pickup_schedule: this.limitedRelease
            };
            this.$store
              .dispatch("products/updateLimitedRelease", updateLimitedRelease)
              .then(result => {
                this.savingLimitedRelease = false;
                this.$toasted.show(`Product Saved Successfully!`, {
                  position: "bottom-right",
                  duration: 2000
                });
                // this.$router.push({ name: "products" });
              });
          } else {
            this.$toasted.show(`Product Saved Successfully!`, {
              position: "bottom-right",
              duration: 2000
            });
          }
        });
      }
    }
  }
};
</script>
